(function () {
    'use strict';

    let ftrFixed = document.getElementById('js--ftr-fixed');
    let SHOW_CLASS = 'show';
    let SCROLL_THRESHOLD = 300;

    if (!ftrFixed) return;

    function toggleFtrFixed() {
        let scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (scrollY >= SCROLL_THRESHOLD) {
            ftrFixed.classList.add(SHOW_CLASS);
        } else {
            ftrFixed.classList.remove(SHOW_CLASS);
        }
    }

    window.addEventListener('scroll', toggleFtrFixed);
    window.addEventListener('DOMContentLoaded', toggleFtrFixed); // for initial load
    window.addEventListener('load', toggleFtrFixed); // just in case after images load

})();
